import {
	FORMULA_OPERATIONS as FP,
	GeometryTypes,
	PathOperationTypes,
	ShapeType,
} from "../widgets/interfaces/model/enumerations/index";
import { IPresetGeometry } from "../widgets/interfaces/model/geometry/PresetGeometry";

/**
 * triangle preset definition
 * ECMA-376, Third Edition, Part 1 - Fundamentals And Markup Language Reference
 * /OfficeOpenXML-DrawingMLGeometries/presetShapeDefinitions.xml
 */

export const triangle: IPresetGeometry = {
	ahLst: [
		{ gdRefX: "adj", maxX: 100000, minX: 0, pos: { x: "x2", y: "t" } },
	],
	avList: [
		{ name: "adj", fmla: { operation: FP.LiteralValue, operands: [50000] } },
	],

	gdLst: [
		{ name: "a", fmla: { operation: FP.PinTo, operands: [0, "adj", 100000] } },
		{ name: "x1", fmla: { operation: FP.MultiplyDivide, operands: ["w", "a", 200000] } },
		{ name: "x2", fmla: { operation: FP.MultiplyDivide, operands: ["w", "a", 100000] } },
		{ name: "x3", fmla: { operation: FP.AddSubtract, operands: ["x1", "wd2", 0] } },

	],

	pathLst: [{
		operations: [
			{ pt: { x: "l", y: "b" }, type: PathOperationTypes.MOVE_TO },
			{ pt: { x: "x2", y: "t" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "r", y: "b" }, type: PathOperationTypes.LINE_TO },
			{ type: PathOperationTypes.CLOSE },
		],
	}],
	presetShape: ShapeType.triangle,
	rect: { l: "x1", t: "vc", r: "x3", b: "b" },
	type: GeometryTypes.PRESET,
};

/**
 * Microsoft open xml preset definition (for Reference purpose only)
 *
 * <triangle>
 *  <avLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *       <gd name="adj" fmla="val 50000" />
 *  </avLst>
 *  <gdLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *      <gd name="a" fmla="pin 0 adj 100000" />
 *      <gd name="x1" fmla="* / w a 200000" />
 *      <gd name="x2" fmla="* / w a 100000" />
 *      <gd name="x3" fmla="+- x1 wd2 0" />
 *  </gdLst>
 *  <ahLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *      <ahXY gdRefX="adj" minX="0" maxX="100000">
 *          <pos x="x2" y="t" />
 *      </ahXY>
 *  </ahLst>
 *  <cxnLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *      <cxn ang="3cd4">
 *        <pos x="x2" y="t" />
 *      </cxn>
 *      <cxn ang="cd2">
 *        <pos x="x1" y="vc" />
 *      </cxn>
 *      <cxn ang="cd4">
 *         <pos x="l" y="b" />
 *      </cxn>
 *      <cxn ang="cd4">
 *         <pos x="x2" y="b" />
 *      </cxn>
 *      <cxn ang="cd4">
 *         <pos x="r" y="b" />
 *      </cxn>
 *      <cxn ang="0">
 *        <pos x="x3" y="vc" />
 *       </cxn>
 *  </cxnLst>
 *   <rect l="x1" t="vc" r="x3" b="b" xmlns="http://schemas.openxmlformats.org/drawingml/2006/main" />
 *   <pathLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *     <path>
 *       <moveTo>
 *         <pt x="l" y="b" />
 *       </moveTo>
 *       <lnTo>
 *         <pt x="x2" y="t" />
 *       </lnTo>
 *       <lnTo>
 *         <pt x="r" y="b" />
 *       </lnTo>
 *       <close />
 *     </path>
 *   </pathLst>
 * </triangle>
 */
